export default __webpack_public_path__ + "locales/nl/DownloadDialog.json?hash=fcd5240551d55ffa77ff4b83af6e0782";